<template>
  <div class="questionnaire" v-if="project">
    <div class="questionnaire__content">
      <el-form @submit.stop.prevent="onSubmit">
        <template v-if="project.profileFields">
          <div class="form-group" v-for="(field, key) in project.profileFields" :key="key">
            <template v-if="field.type === 'текст'">
              <el-form-item>
                <label style="display: block; margin-bottom: 8px; font-weight: 500;">{{ field.name }} <span style="color: red;">*</span></label>
                <el-input v-model="user.userProject.profile[field.id]" placeholder="Введите текст" />
              </el-form-item>
            </template>
            <template v-if="field.type === 'большой текст'">
              <el-form-item :label="field.name" :required="true">
                <el-input 
                  type="textarea" 
                  v-model="user.userProject.profile[field.id]" 
                  :rows="4"
                  placeholder="Введите текст"
                />
              </el-form-item>
            </template>
            <template v-if="field.type === 'целое число'">
              <el-form-item>
                <label style="display: block; margin-bottom: 8px; font-weight: 500;">{{ field.name }} <span style="color: red;">*</span></label>
                <el-input 
                  v-model="user.userProject.profile[field.id]" 
                  type="number"
                  placeholder="Введите число"
                />
              </el-form-item>
            </template>
            <template v-if="field.type === 'дата'">
              <el-form-item :label="field.name" :required="true">
                <el-date-picker
                  v-model="user.userProject.profile[field.id]"
                  type="datetime"
                  placeholder="Выберите дату"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                />
              </el-form-item>
            </template>
            <template v-if="field.type === 'дробное число'">
              <el-form-item :label="field.name" :required="true">
                <el-input-number v-model="user.userProject.profile[field.id]" :min="0.1" :precision="2" />
              </el-form-item>
            </template>
            <template v-if="field.type === 'единственный выбор'">
              <el-form-item>
                <label style="display: block; margin-bottom: 8px; font-weight: 500;">{{ field.name }} <span style="color: red;">*</span></label>
                <el-radio-group v-model="user.userProject.profile[field.id]">
                  <el-radio 
                    v-for="choice in field.profileFieldChoices" 
                    :key="choice.id" 
                    :label="choice.name"
                    style="display: block; margin-bottom: 10px;"
                  >
                    {{ choice.name }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </template>
            <template v-if="field.type === 'множественный выбор'">
              <el-form-item :label="field.name" :required="true">
                <el-checkbox-group v-model="user.userProject.profile[field.id]">
                  <el-checkbox 
                    v-for="choice in field.profileFieldChoices" 
                    :key="choice.id" 
                    :label="choice.name"
                  >
                    {{ choice.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </template>
            <template v-if="field.type === 'город и регион'">
              <el-form-item label="Регион" :required="true">
                <el-select 
                  v-model="selectedRegionId" 
                  @change="handleRegionChange(selectedRegionId, field.id)"
                  placeholder="Выберите регион"
                  :loading="isRegionsLoading"
                  filterable
                  style="width: 100%;"
                >
                  <el-option 
                    v-for="regionItem in regions" 
                    :key="regionItem.id" 
                    :label="regionItem.regionNameRu" 
                    :value="regionItem.id"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="Город" :required="true">
                <el-select 
                  v-model="selectedCityId" 
                  @change="handleCityChange(selectedCityId, field.id)"
                  placeholder="Выберите город"
                  :disabled="!selectedRegionId"
                  filterable
                  style="width: 100%;"
                >
                  <el-option 
                    v-for="cityItem in cities" 
                    :key="cityItem.id" 
                    :label="cityItem.name" 
                    :value="cityItem.id"
                  />
                </el-select>
              </el-form-item>
            </template>
          </div>
        </template>
        <div class="questionnaire__actions">
          <el-button @click="onSubmit" class="btn btn-black">ОТПРАВИТЬ АНКЕТУ</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { eventBus } from "../main";

export default {
  name: "Questionnaire",
  props: ['project'],
  data() {
    return {
      isRegionsLoading: false,
      selectedRegionId: null,
      selectedCityId: null,
      cities: [],
      regions: [],
      user: {
        userInstitution: {},
        userProject: {
          profile: {},
        }
      }
    }
  },
  watch: {
    project: {
      handler(newProject) {
        console.log('Project changed in Questionnaire:', newProject);
        if (newProject && newProject.profileFields) {
          console.log('Profile fields:', newProject.profileFields);
          // Инициализируем поля профиля
          newProject.profileFields.forEach(field => {
            console.log('Initializing field:', field.name, field.type, field.id);
            if (field.type === 'множественный выбор') {
              this.$set(this.user.userProject.profile, field.id, []);
            } else if (field.type === 'единственный выбор') {
              this.$set(this.user.userProject.profile, field.id, '');
            } else if (field.type === 'город и регион') {
              this.$set(this.user.userProject.profile, field.id, null);
            } else {
              this.$set(this.user.userProject.profile, field.id, '');
            }
          });
          console.log('Initialized profile:', this.user.userProject.profile);
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.findRegions()
  },
  methods: {
    validateForm() {
      // Простая валидация - проверяем, что все обязательные поля заполнены
      if (!this.project || !this.project.profileFields) {
        return true;
      }

      for (let field of this.project.profileFields) {
        const value = this.user.userProject.profile[field.id];
        if (!value || (Array.isArray(value) && value.length === 0)) {
          this.$message.error(`Поле "${field.name}" обязательно для заполнения`);
          return false;
        }
      }
      return true;
    },
    onSubmit() {
      if (!this.validateForm()) {
        return;
      }

      console.log('Submitting questionnaire:', this.user.userProject.profile);
      this.axios.post('user_projects', {
        profile: this.user.userProject.profile,
        project: this.project.id
      }).then(() => {
        console.log('Questionnaire submitted successfully');
        this.$message.success('Анкета успешно отправлена!');
        eventBus.$emit('enroll');
      }).catch(error => {
        console.error('Error submitting questionnaire:', error);
        this.$message.error('Ошибка при отправке анкеты');
      });
    },
    findRegions() {
      this.isRegionsLoading = true;
      this.axios.get(`region-list`).then(res => {
        this.isRegionsLoading = false;
        this.regions = res.data.data;
      });
    },
    handleRegionChange(regionId, fieldId) {
      console.log('Region changed:', regionId, 'fieldId:', fieldId);
      this.selectedCityId = null;
      this.cities = [];
      
      if (regionId) {
        // Находим объект региона и сохраняем его
        const region = this.regions.find(r => r.id === regionId);
        if (region) {
          this.$set(this.user.userProject.profile, fieldId, region);
        }
        
        // Загружаем города
        this.axios.get(`city-list?region=${regionId}&hideLoader=true`)
          .then(res => {
            console.log('Cities loaded:', res.data.data);
            this.cities = res.data.data;
          })
          .catch(error => {
            console.error('Error loading cities:', error);
          });
      }
    },
    handleCityChange(cityId, fieldId) {
      console.log('City changed:', cityId, 'fieldId:', fieldId);
      if (cityId) {
        // Находим объект города и сохраняем его
        const city = this.cities.find(c => c.id === cityId);
        if (city) {
          this.$set(this.user.userProject.profile, fieldId, city);
        }
      }
    },
  }
}
</script>

<style scoped>
.questionnaire {
  padding: 0;
}

.questionnaire__content {
  width: 100%;
}

.questionnaire__actions {
  margin-top: 20px;
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

.el-form-item {
  margin-bottom: 15px;
}

.el-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.el-checkbox {
  margin-right: 0;
}

.el-form-item {
  display: block !important;
}

.el-form-item__label {
  display: block !important;
  float: none !important;
  width: 100% !important;
  margin-bottom: 8px !important;
}

.el-form-item__content {
  display: block !important;
  margin-left: 0 !important;
  width: 100% !important;
}



</style>
